// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.allStopsList_stopListsContainer_SNGqm {
  padding-top: 1.2rem;
  max-width: 95%;
  break-inside: avoid;
}

.allStopsList_stopList_sKJth {
  margin-bottom: 1rem;
  padding-left: 1.2rem;
}

.allStopsList_lineInfoText_qBdAk {
  font-family: GothamRounded-Medium;
  font-size: 1rem;
}

.allStopsList_stopListText_RynI1 {
  font-family: GothamRounded-Book;
  font-size: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/lineTimetable/allStopsList.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB","sourcesContent":[".stopListsContainer {\n  padding-top: 1.2rem;\n  max-width: 95%;\n  break-inside: avoid;\n}\n\n.stopList {\n  margin-bottom: 1rem;\n  padding-left: 1.2rem;\n}\n\n.lineInfoText {\n  font-family: GothamRounded-Medium;\n  font-size: 1rem;\n}\n\n.stopListText {\n  font-family: GothamRounded-Book;\n  font-size: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stopListsContainer": `allStopsList_stopListsContainer_SNGqm`,
	"stopList": `allStopsList_stopList_sKJth`,
	"lineInfoText": `allStopsList_lineInfoText_qBdAk`,
	"stopListText": `allStopsList_stopListText_RynI1`
};
module.exports = ___CSS_LOADER_EXPORT___;
